import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Storage } from '@ionic/storage';
import { DialogData } from 'src/app/common/delete-alert/delete-alert.component';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-ratewise-currentstock',
  templateUrl: './ratewise-currentstock.component.html',
  styleUrls: ['./ratewise-currentstock.component.scss']
})
export class RatewiseCurrentstockComponent implements OnInit {
  responseData: any;
  loadingTrue = false;
  errorTrue = false;
  btnClicked = false;
  GodwonTrue = false;
  selectedItem: any = {
    ic: '',
    ina: '',
    regina: '',
    refn: '',
    sr: '',
    tp: '',
    cc: '',
    dp: '',
    da: '',
    sq: '',
    fd: '',
    stkchk: '',
    mpchk: '',
    reftype: '',
    ssetup: []
  };
  items: any[];
  ic = '';
  qty: any = '';
  godowncode = '';
  selected = [];
  xindex = 0;
  singleSelect = {
    sr: '',
    godowndetails: [],
  };
  datas = {
    pricelistname1: {
      required: 'NO',
      caption: ''
    },
    pricelistname2: {
      required: 'NO',
      caption: ''
    },
    pricelistname3: {
      required: 'NO',
      caption: ''
    },
    pricelistname4: {
      required: 'NO',
      caption: ''
    },
    pricelistname5: {
      required: 'NO',
      caption: ''
    },
    pricelistname6: {
      required: 'NO',
      caption: ''
    },
  };
  bc = '';
  reftype = '';
  matrix1code = '';
  matrix2code = '';
  matrix3code = '';
  matrix4code = '';
  matrix5code = '';
  matrix6code = '';
  matrix7code = '';
  matrix8code = '';
  matrix9code = '';
  matrix10code = '';
  scanbarcode = '';
  barcode = '';
  bbc = '';
  bcid = '';
  constructor(
    public dialogRef: MatDialogRef<RatewiseCurrentstockComponent>,
    @Inject(MAT_DIALOG_DATA) public xdata: DialogData,
    public data: DataService,
    public storage: Storage
  ) {
    this.responseData = this.xdata;
    this.ic = this.responseData.ic;
    this.qty = this.responseData.qty;
    if (this.responseData.godowncode) {
      this.godowncode = this.responseData.godowncode;
    }
    this.bc = this.responseData.bc;
    this.reftype = this.responseData.reftype;
    this.matrix1code = this.responseData.matrix1code;
    this.matrix2code = this.responseData.matrix2code;
    this.matrix3code = this.responseData.matrix3code;
    this.matrix4code = this.responseData.matrix4code;
    this.matrix5code = this.responseData.matrix5code;
    this.matrix6code = this.responseData.matrix6code;
    this.matrix7code = this.responseData.matrix7code;
    this.matrix8code = this.responseData.matrix8code;
    this.matrix9code = this.responseData.matrix9code;
    this.matrix10code = this.responseData.matrix10code;
    this.scanbarcode = this.responseData.scanbarcode;
    this.barcode = this.responseData.barcode;
    this.bbc = this.responseData.bbc;
    if (this.scanbarcode === 'SCANBARCODE') {
      this.bcid = this.bc;
    } else if (this.barcode === 'BARCODE') {
      this.bcid = this.bbc
    } else {
      this.bcid = '';
    }
  }

  ngOnInit() {
    this.getPriceList();
    if (this.reftype != 'MATRIX' && this.scanbarcode === '' && this.barcode === '') {
      this.getData();
    }
    else if (this.reftype === 'MATRIX' || (this.scanbarcode === 'SCANBARCODE') || (this.barcode === 'BARCODE')) {
      this.getDataMatrix();
    }
    console.log(this.godowncode);
    if (this.data.authorizationResponse.edition_features.multiwarehouses === 'YES' && this.data.authorizationkey.branchwisesetup.multigodownrequired === 'YES' && this.godowncode === '') {
      this.GodwonTrue = true;
    }
  }

  getData(): void {
    this.loadingTrue = true;
    if (this.godowncode === '') {
      this.data.getData('item/' + this.ic + '/ratewisestock').then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.items = this.responseData.data;
          // let list = {
          //   qty: '100',
          //   sr: '45',
          //   dlrp: '45',
          //   mrp: '45',
          //   p1: '45',
          //   p2: '45',
          //   p3: '45',
          //   p4: '45',
          //   p5: '45',
          //   p6: '45',
          //   godowndetails: [],
          // }
          this.items.forEach(element => {
            element.viewgodwon = false;
            element.godowndetails.forEach(element2 => {
              element2.avqty = element2.qty;
              element2.qty = '0';
            });
            // list.godowndetails = element.godowndetails;
          });
          // this.items.push(list);
        } else {
          this.items = [];
        }
        this.loadingTrue = false;
      }, (error) => { });
    } else {
      const obj = {
        ic: this.ic,
        bc: this.bcid,
        godowncode: this.godowncode,
      };
      this.data.postData('item/ratewisestock', obj).then((success) => {
        this.responseData = success;
        if (this.responseData.Status === true) {
          this.items = this.responseData.data;
          this.items.forEach(element => {
            element.viewgodwon = false;
            element.godowndetails.forEach(element2 => {
              element2.avqty = element2.qty;
              element2.qty = '0';
            });
          });
        } else {
          this.items = [];
        }
        this.loadingTrue = false;
      }, (error) => { });
    }
  }

  getDataMatrix() {
    this.loadingTrue = true;
    const obj = {
      ic: this.ic,
      bc: this.bcid,
      godowncode: this.godowncode,
      matrix1code: this.matrix1code,
      matrix2code: this.matrix2code,
      matrix3code: this.matrix3code,
      matrix4code: this.matrix4code,
      matrix5code: this.matrix5code,
      matrix6code: this.matrix6code,
      matrix7code: this.matrix7code,
      matrix8code: this.matrix8code,
      matrix9code: this.matrix9code,
      matrix10code: this.matrix10code
    };
    this.data.postData('item/ratewisestock', obj).then((success) => {
      this.responseData = success;
      if (this.responseData.Status === true) {
        this.items = this.responseData.data;
        this.items.forEach(element => {
          element.viewgodwon = false;
          element.godowndetails.forEach(element2 => {
            element2.avqty = element2.qty;
            element2.qty = '0';
          });
        });
      } else {
        this.items = [];
      }
      this.loadingTrue = false;
    }, (error) => { });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isSelected(val) {
    if (this.selected.length > 0) {
      const index = this.selected.map(c => c.sr).indexOf(val.sr);
      if (index === -1) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  goNext(): void {
    this.dialogRef.close({
      selectedbill: this.singleSelect,
      qty: this.qty,
      select: true
    });
  }

  selectrate(val) {
    if (this.GodwonTrue === false) {
      this.singleSelect = val;
      this.goNext();
    } else {
      if (val.sr != this.singleSelect.sr) {
        this.singleSelect = val;
        this.showGodwon(val);
      }
    }
  }
  select(val) {
    if (val.sr != this.singleSelect.sr) {
      this.showGodwon(val);
    }
    this.singleSelect = val;
  }
  showGodwon(val) {
    this.items.forEach(element => {
      if (val.sr === element.sr) {
        element.viewgodwon = true;
      } else {
        element.viewgodwon = false;
        this.qty = 0;
        element.godowndetails.forEach(element2 => {
          element2.qty = '0';
        });
      }
    });
  }

  getqty(val, godn) {
    this.singleSelect = val;
    this.qty = 0;
    if (godn.qty === '') { godn.qty = '0'; }
    if (parseFloat(godn.qty) > parseFloat(godn.avqty)) { this.data.openAlertFalse('Qty is more then Avilable Qty'); }
    val.godowndetails.forEach(element2 => {
      this.qty = this.qty + parseFloat(element2.qty);
    });
  }

  verify() {
    let test = false;
    if (this.singleSelect.sr === '') {
      this.goNext();
    } else {
      this.items.forEach(element => {
        element.godowndetails.forEach(element2 => {
          if (element2.qty != '0' && element2.qty != '' && element2.qty != 0) {
            test = true;
            if (parseFloat(element2.qty) <= parseFloat(element2.avqty)) {
              this.goNext();
            } else { this.data.openAlertFalse('Qty is more then Avilable Qty'); }
          } else {
            setTimeout(() => {
              if (!test) {
                this.data.openAlertFalse('please add Godown Qty');
              }
            }, 800);
          }
        });
      });
    }
  }

  getPriceList() {
    this.storage.get('pricelist').then((val) => {
      if (val) {
        this.datas = val;
      }
    });
  }
}
